import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { actions } from 'modules/notifications';

import view from './view';

const mapStateToProps = createStructuredSelector({
  notifications: s => s.notifications,
});

export default connect(mapStateToProps, { remove: actions.remove })(view);
